define('meeting-modal/calendar-plugins/calendar-plugins',['require','i18next','bowser','lodash'],function (require) {
    var i18n = require('i18next');
    var bowser = require('bowser');
    var _ = require('lodash');

    var self = this;

    self.installCalendarHtml = function () {
        // Include target="_blank" in the HTML, otherwise popup blockers will be activated.
        if (_.contains(navigator.userAgent.toLowerCase(), 'windows')) {
            if (bowser.msie) {
                return i18n.t('meeting.installCalendar.outlook',
                  '<a href="#" target="_blank" data-bind="click: trackOutlookLink">',
                  '</a>');
            }
            return i18n.t('meeting.installCalendar.both',
              '<a href="#" target="_blank" data-bind="click: trackOutlookLink">',
              '</a>',
              '<a target="_blank" data-bind="click: trackGoogleCalendarLink">',
              '</a>');
        } else if (_.contains(navigator.appVersion.toLowerCase(), 'mac')) {
            return i18n.t('meeting.installCalendar.both',
              '<a href="#" target="_blank" data-bind="click: trackOutlookLink">',
              '</a>',
              '<a target="_blank" data-bind="click: trackGoogleCalendarLink">',
              '</a>');
        }
        return undefined;
    };

    self.trackOutlookLink = function () {
        var outlookLink = 'https://www.gotomeeting.com/features/quick-one-click-meetings';

        window.mixpanel.track('Outlook Support Link');
        window.open(outlookLink);
    };

    self.trackGoogleCalendarLink = function () {
        var googleCalendarLink = 'https://www.gotomeeting.com/features/quick-one-click-meetings';

        window.mixpanel.track('Google Calendar Link');
        window.open(googleCalendarLink);
    };

    return {

    };
});

